module.exports = __webpack_public_path__ + "img/pin-synapse.952530db.png";